import React from 'react';
import { Tag } from 'antd';
import { StyledFlowTitle } from '../FlowNavTitle/styled';

const FrustrationSignalNavTitle = ({
  signalId,
  signalConfigMeta,
}: {
  signalId: string;
  signalConfigMeta: any;
}) => {
  const currentSignal = signalConfigMeta?.[signalId];
  return (
    <StyledFlowTitle>
      <Tag color="#ff4d4f">Frustration Signal</Tag>
      <span>{currentSignal?.name || 'Deleted Signal'}</span>
    </StyledFlowTitle>
  );
};

export default FrustrationSignalNavTitle;
